// Utilities for retrieving various types of data for Music Lab.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var AppConfig = require('../appConfig').default;
export var baseUrl = 'https://curriculum.code.org/media/musiclab/';
var LevelSource;
(function (LevelSource) {
    LevelSource["LEVELS"] = "LEVELS";
    LevelSource["LEVEL"] = "LEVEL";
    LevelSource["FILE"] = "FILE";
})(LevelSource || (LevelSource = {}));
// Exporting enum as object for use in JS files
export var LevelSources = {
    LEVELS: LevelSource.LEVELS,
    LEVEL: LevelSource.LEVEL,
    FILE: LevelSource.FILE,
};
// Loads a sound library JSON file.
export var loadLibrary = function () { return __awaiter(void 0, void 0, void 0, function () {
    var localLibraryFilename, localLibrary, libraryParameter, libraryFilename, response, library;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(AppConfig.getValue('local-library') === 'true')) return [3 /*break*/, 1];
                localLibraryFilename = 'music-library';
                localLibrary = require("@cdo/static/music/".concat(localLibraryFilename, ".json"));
                return [2 /*return*/, localLibrary];
            case 1:
                libraryParameter = AppConfig.getValue('library');
                libraryFilename = libraryParameter
                    ? "music-library-".concat(libraryParameter, ".json")
                    : 'music-library.json';
                return [4 /*yield*/, fetch(baseUrl + libraryFilename)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                library = _a.sent();
                return [2 /*return*/, library];
        }
    });
}); };
// Loads a progression file.  This file can be used for prototyping a progression
// before it's split into proper levels.
var loadProgressionFile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var defaultProgressionFilename, progression, progressionParameter, progressionFilename, response, progression;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(AppConfig.getValue('local-progression') === 'true')) return [3 /*break*/, 1];
                defaultProgressionFilename = 'music-progression';
                progression = require("@cdo/static/music/".concat(defaultProgressionFilename, ".json"));
                return [2 /*return*/, progression];
            case 1:
                progressionParameter = AppConfig.getValue('progression');
                progressionFilename = progressionParameter
                    ? "music-progression-".concat(progressionParameter, ".json")
                    : 'music-progression.json';
                return [4 /*yield*/, fetch(baseUrl + progressionFilename)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                progression = _a.sent();
                return [2 /*return*/, progression];
        }
    });
}); };
// Loads level data from the dashboard, for a script level or a level.
var loadLevelData = function (levelDataPath) { return __awaiter(void 0, void 0, void 0, function () {
    var response, levelData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(levelDataPath)];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error('Response not ok');
                }
                return [4 /*yield*/, response.json()];
            case 2:
                levelData = _a.sent();
                return [2 /*return*/, levelData];
        }
    });
}); };
// Loads a progression step.
export var loadProgressionStepFromSource = function (levelSource, levelDataPath, currentLevelIndex) { return __awaiter(void 0, void 0, void 0, function () {
    var progressionStep, levelCount, response, response, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                progressionStep = undefined;
                levelCount = undefined;
                if (!(levelSource === LevelSource.LEVELS)) return [3 /*break*/, 2];
                return [4 /*yield*/, loadLevelData(levelDataPath)];
            case 1:
                response = _a.sent();
                progressionStep = response.level_data;
                return [3 /*break*/, 6];
            case 2:
                if (!(levelSource === LevelSource.LEVEL)) return [3 /*break*/, 4];
                return [4 /*yield*/, loadLevelData(levelDataPath)];
            case 3:
                response = _a.sent();
                progressionStep = response.level_data;
                levelCount = 1;
                return [3 /*break*/, 6];
            case 4:
                if (!(levelSource === LevelSource.FILE)) return [3 /*break*/, 6];
                return [4 /*yield*/, loadProgressionFile()];
            case 5:
                response = _a.sent();
                progressionStep = response.steps[currentLevelIndex];
                levelCount = response.steps.length;
                _a.label = 6;
            case 6: return [2 /*return*/, { progressionStep: progressionStep, levelCount: levelCount }];
        }
    });
}); };
